// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.kcAVhsh3VGpnheUe3KE1 {
  height: calc(100% - 56px);
  padding: 16px;
  background: rgba(var(--secondary-bg), 0.40);
  border-radius: 24px 24px 0 0;
}

.R7_Xr34dSxjpkLt9inis {
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 510;
  line-height: 32px; /* 100% */
  letter-spacing: -0.264px;
  color: rgb(var(--placeholder-primary));
  margin-bottom: 24px;
  }


/*--------------------search--------------------*/


.xONLjVgJroKOMOq5SDD9 {
  border-radius: 20px;
  border: 0px;
  background: rgba(var(--tertiary-bg-dark), 0.3);
  color: rgb(var(--placeholder-primary-dark));
  padding: 16px 68px 16px 50px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
}

.LMd5yNhXRYN8rbAcl18h {
  position: relative;
  margin-bottom: 8px;
}

.VEpEHJFiOF1QvIJX0Mwu {
  position: absolute;
  left: 17px;
  top: 50%;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
  > path {
    stroke: #98989E;
  }
}

.lG_fBPejfsDDwaZzKeuj {
    position: absolute;
    right: 45px;
    top: 52%;
    width: 20px;
    height: 20px;
    transform: translateY(-50%);
    z-index: 201;
    cursor: pointer;
}


.X5xdAUVsSC61f0AClXKd {
  position: absolute;
  right: 15px;
  top: 52%;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  z-index: 201;
  cursor: pointer;
}

/*--------------------/search--------------------*/

.BPhS9lJVesB6wU0WPIjh {
  font-size: 15px;
  line-height: 138%;
  letter-spacing: 0.07px;
  color: #8E8E93;
}

.NQ9nFejo3Yc5ELlUlafw {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  outline: none;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 70px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.NQ9nFejo3Yc5ELlUlafw > div {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*--------------------send-to--------------------*/

/*--------------------trans item--------------------*/

.TnffDmiH2rwUc1_KbFEj {
  max-height: 100%;
  overflow-y: auto;
}

.uWhUOGUKpaf9Mb51R2xs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: relative;
  padding: 10px 0;
  cursor: pointer;
}

/* 
.transItem:not(:last-child) {
  margin-bottom: 10px;
} */

.uWhUOGUKpaf9Mb51R2xs::after {
  content: '';
  position: absolute;
  width: calc(100% - 51.1px);
  height: 1px;
  bottom: 0;
  right: 0;
  background: rgba(116, 116, 128, 0.4);
}

.yI6FRnO3VqtNGJIGGj8t {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ZOOyCYKG6PwMt0ya9NKn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #007AFF;
  font-size: 18px;
  font-weight: 760;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.PBTc_MLnkOF7wFSLudXz {
  font-size: 17px;
  color: rgb(var(--placeholder-primary));
  font-weight: 540;
}

._9LPiNm08nMQuf4dskVA {
  text-align: left;
  font-size: 14px;
  color: rgb(var(--placeholder-secondary));
}
  
/*--------------------/trans item--------------------*/
  
/*--------------------/send-to--------------------*/

.KU3uCjbdKuAFxCGJX9yd {
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
  text-align: center;
  font-size: 21px;
  font-weight: 540;
}

.zgmf_7SNoxAnACuCw0Zr {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.SrEiG31Psva9QvXxP9qd {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.aPmGqk4yK0ozo1PcuG7v {
  height: 100%;
  width: 100%;
  object-fit: contain;
  /* border-radius: 20px; */
}

.oWxb0P8Y655hEkVelYXo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.cU3zdL6FS3VOuQxhSzK3 {
  width: 66%;
  height: 0;
  padding-bottom: 66%;
  background-color: transparent;
  box-shadow: 0px 0px 0px 9999px rgb(var(--primary-bg));
  border-radius: 15px;
  z-index: 302;

  position: relative;
  border: 1.5px dashed rgb(var(--placeholder-primary));
}

.bVFtwjIe269_A67PKMID {
  position: absolute;
  top: -15%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150%;
  text-align: center;
  color: rgb(var(--placeholder-primary));
}`, "",{"version":3,"sources":["webpack://./src/pages/nft-detail/send-nft/send-to/send-to.module.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,aAAa;EACb,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB;;;AAGF,iDAAiD;;;AAGjD;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C,2CAA2C;EAC3C,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B;IACE,eAAe;EACjB;AACF;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,eAAe;AACnB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,eAAe;AACjB;;AAEA,kDAAkD;;AAElD;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kDAAkD;;AAElD,qDAAqD;;AAErD;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,SAAS;EACT,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,sDAAsD;;AAEtD,mDAAmD;;AAEnD;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;;EAEZ,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC","sourcesContent":["\n.seleсtWrapper {\n  height: calc(100% - 56px);\n  padding: 16px;\n  background: rgba(var(--secondary-bg), 0.40);\n  border-radius: 24px 24px 0 0;\n}\n\n.modalTitle {\n  text-align: center;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 32px; /* 100% */\n  letter-spacing: -0.264px;\n  color: rgb(var(--placeholder-primary));\n  margin-bottom: 24px;\n  }\n\n\n/*--------------------search--------------------*/\n\n\n.search {\n  border-radius: 20px;\n  border: 0px;\n  background: rgba(var(--tertiary-bg-dark), 0.3);\n  color: rgb(var(--placeholder-primary-dark));\n  padding: 16px 68px 16px 50px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 125% */\n  letter-spacing: -0.5px;\n}\n\n.searchInner {\n  position: relative;\n  margin-bottom: 8px;\n}\n\n.searchIcon {\n  position: absolute;\n  left: 17px;\n  top: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translateY(-50%);\n  > path {\n    stroke: #98989E;\n  }\n}\n\n.import {\n    position: absolute;\n    right: 45px;\n    top: 52%;\n    width: 20px;\n    height: 20px;\n    transform: translateY(-50%);\n    z-index: 201;\n    cursor: pointer;\n}\n\n\n.scan {\n  position: absolute;\n  right: 15px;\n  top: 52%;\n  width: 20px;\n  height: 20px;\n  transform: translateY(-50%);\n  z-index: 201;\n  cursor: pointer;\n}\n\n/*--------------------/search--------------------*/\n\n.assetsTitle {\n  font-size: 15px;\n  line-height: 138%;\n  letter-spacing: 0.07px;\n  color: #8E8E93;\n}\n\n.searchClear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  outline: none;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  right: 70px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.searchClear > div {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/*--------------------send-to--------------------*/\n\n/*--------------------trans item--------------------*/\n\n.transItems {\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n.transItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  position: relative;\n  padding: 10px 0;\n  cursor: pointer;\n}\n\n/* \n.transItem:not(:last-child) {\n  margin-bottom: 10px;\n} */\n\n.transItem::after {\n  content: '';\n  position: absolute;\n  width: calc(100% - 51.1px);\n  height: 1px;\n  bottom: 0;\n  right: 0;\n  background: rgba(116, 116, 128, 0.4);\n}\n\n.transItemLeft {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.transItemLogo {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #007AFF;\n  font-size: 18px;\n  font-weight: 760;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.transItemLeftFrom {\n  font-size: 17px;\n  color: rgb(var(--placeholder-primary));\n  font-weight: 540;\n}\n\n.transItemDate {\n  text-align: left;\n  font-size: 14px;\n  color: rgb(var(--placeholder-secondary));\n}\n  \n/*--------------------/trans item--------------------*/\n  \n/*--------------------/send-to--------------------*/\n\n.emptyTransactions {\n  height: 70vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -20px;\n  text-align: center;\n  font-size: 21px;\n  font-weight: 540;\n}\n\n.qrContent {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.qr {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.qrCamera {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  /* border-radius: 20px; */\n}\n\n.qrBack {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.qrArea {\n  width: 66%;\n  height: 0;\n  padding-bottom: 66%;\n  background-color: transparent;\n  box-shadow: 0px 0px 0px 9999px rgb(var(--primary-bg));\n  border-radius: 15px;\n  z-index: 302;\n\n  position: relative;\n  border: 1.5px dashed rgb(var(--placeholder-primary));\n}\n\n.scanText {\n  position: absolute;\n  top: -15%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 150%;\n  text-align: center;\n  color: rgb(var(--placeholder-primary));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"seleсtWrapper": `kcAVhsh3VGpnheUe3KE1`,
	"modalTitle": `R7_Xr34dSxjpkLt9inis`,
	"search": `xONLjVgJroKOMOq5SDD9`,
	"searchInner": `LMd5yNhXRYN8rbAcl18h`,
	"searchIcon": `VEpEHJFiOF1QvIJX0Mwu`,
	"import": `lG_fBPejfsDDwaZzKeuj`,
	"scan": `X5xdAUVsSC61f0AClXKd`,
	"assetsTitle": `BPhS9lJVesB6wU0WPIjh`,
	"searchClear": `NQ9nFejo3Yc5ELlUlafw`,
	"transItems": `TnffDmiH2rwUc1_KbFEj`,
	"transItem": `uWhUOGUKpaf9Mb51R2xs`,
	"transItemLeft": `yI6FRnO3VqtNGJIGGj8t`,
	"transItemLogo": `ZOOyCYKG6PwMt0ya9NKn`,
	"transItemLeftFrom": `PBTc_MLnkOF7wFSLudXz`,
	"transItemDate": `_9LPiNm08nMQuf4dskVA`,
	"emptyTransactions": `KU3uCjbdKuAFxCGJX9yd`,
	"qrContent": `zgmf_7SNoxAnACuCw0Zr`,
	"qr": `SrEiG31Psva9QvXxP9qd`,
	"qrCamera": `aPmGqk4yK0ozo1PcuG7v`,
	"qrBack": `oWxb0P8Y655hEkVelYXo`,
	"qrArea": `cU3zdL6FS3VOuQxhSzK3`,
	"scanText": `bVFtwjIe269_A67PKMID`
};
export default ___CSS_LOADER_EXPORT___;
